// utils/buildAssetFilterCatalogHttp.js
import { app } from '../firebase'; // ← use your initialized app as a fallback

export async function buildAssetFilterCatalogHttp({
  organizationId,
  aufId,
  authToken,                 // await getToken() once
  region = 'us-central1',
  projectId,                 // e.g., "myutms-f8cba" (may be undefined)
}) {
  // Resolve a reliable projectId.
  const resolvedProject =
    (projectId && String(projectId).trim()) ||
    process.env.REACT_APP_FIREBASE_PROJECT_ID ||
    process.env.NX_FIREBASE_PROJECT_ID ||
    process.env.VITE_FIREBASE_PROJECT_ID ||
    app?.options?.projectId ||                     // ← initialized app
    (typeof window !== 'undefined' &&
      (window?.firebase?.apps?.[0]?.options?.projectId ||
       window?.firebaseApp?.options?.projectId)) ||
    '';

  if (!resolvedProject) {
    throw new Error(
      '[buildAssetFilterCatalogHttp] projectId is missing. ' +
      'Pass { projectId } or ensure an env var like ' +
      'REACT_APP_FIREBASE_PROJECT_ID is set (and dev server restarted).'
    );
  }

  const url =
    `https://${region}-${resolvedProject}.cloudfunctions.net/` +
    `buildAssetFilterCatalogHttp`;

  // Optional: quick debug
  // console.log('[buildAssetFilterCatalogHttp] POST', url, { organizationId, aufId });

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ organizationId, aufId }),
  });

  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const err = await res.json();
      if (err?.error) msg = err.error;
    } catch (_) {}
    throw new Error(`buildAssetFilterCatalog failed: ${msg}`);
  }
  return res.json();
}
